module.exports = __webpack_public_path__ + "static/media/email@2x.02eceae3.png";